<div [class.hsm-modal]="!isSignable" [class.signable-quick-qink]="isSignable" [id]="modalable?.getModalId()"
     aria-hidden="true"
     class="modal quicklink-modal" data-backdrop="static" data-keyboard="false" role="dialog" tabindex="-1">

    <div [class.error]="err" class="modal-dialog modal-fullscreen" role="document">
        <div class="modal-content">
            <div class="modal-body">

                @if (!isSignable) {
                    @if (loading) {
                        <div class="loading">
                            <div>Lade Daten</div>
                            <div class="lds-ring">
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>
                        </div>
                    }
                    @if (!loading) {
                        @if (newHSMActive && !err) {
                            <am-root [config]="hsmConfig"></am-root>
                        } @else if (iFrameURL && !err && (!modalable.tmpRedirect || (newHSMActive && modalable.type === 3))) {
                            <iframe [id]="iFrameId" [src]='iFrameURL'></iframe>
                        }
                        @if (!err) {
                            <div class="iframe-overlay"></div>
                        }
                        @if (err) {
                            <div class="error">
                                <div [ngClass]="{'gmt-error': modalable.isGMT()}" class="error-message">
                                    <span>{{ err }}</span>
                                    <button (click)="close()" data-bs-dismiss="modal">zurück zum Buch</button>
                                </div>
                            </div>
                        }
                    }
                }


                @if (isSignable) {
                    @if (specialQuickLinkImageURL) {
                        <p class="me-3 text-center">
                            <img [attr.src]="specialQuickLinkImageURL" alt="Logo des Quicklinks"/>
                        </p>
                    }
                    @if (formData) {
                        <app-quicklink-sign-form [formData]="formData"
                                                 [quickLink]="modalable"></app-quicklink-sign-form>
                    }
                    @if (!formData && !err) {
                        <p>Lade Daten...</p>
                    }
                    <button (click)="close()" class="btn btn-warning close-button" data-bs-dismiss="modal"
                            type="button">
                        <i aria-hidden="true" class="fa fa-times"></i>
                    </button>
                    @if (!quickLinkService.isApprovedLink(modalable)) {
                        <p class="no-accountability">
                            Dieser Link führt zu nicht approbierten Inhalten.
                        </p>
                    }
                    <div [ngClass]="{'error': err, 'modal-footer': !err}">
                        <div [ngClass]="{'error-message': err}">
                            @if (err) {
                                <span>{{ err }}</span>
                            }
                            <button (click)="close()" data-bs-dismiss="modal">zurück zum Buch</button>
                        </div>
                    </div>
                }

            </div>
            @if (!isSignable && !err) {
                <div class="resize-handler">
                    <img src="{{ 'hsm-modal/hsm-window-resize-handle.png' | asset }}">
                </div>
                <div class="drag-handler">
                    <hr>
                    <hr>
                    <div class="modal-toolbar dropdown">
                        <button (click)="maximize()" [disabled]="isMaximized()" class="btn btn-default"><img
                                src="{{ 'hsm-modal/hsm-window-original-size.png' | asset  }}"></button>
                        @if (!dirty) {
                            <button (click)="reloadIFrame()" class="btn btn-default" data-bs-dismiss="modal"><img
                                    src="{{ 'hsm-modal/hsm-window-close.png' | asset }}"></button>
                        }
                        @if (dirty) {
                            <button (click)="close()" class="btn btn-default" data-bs-toggle="dropdown"
                                    id="closeDropdown"><img
                                    src="{{ 'hsm-modal/hsm-window-close.png' | asset }}"></button>
                        }
                        <ul aria-labelledby="closeDropdown" class="dropdown-menu dropdown-menu-end">
                            <div class="dropdown-wrapper">
                                <span>Gelöste Beispiele und Antworten werden <b>nicht gespeichert.</b></span>
                                <button (click)="reloadIFrame()" class="btn btn-danger" data-bs-dismiss="modal">
                                    Verwerfen und schließen
                                </button>
                            </div>
                        </ul>
                    </div>
                </div>
            }
        </div>
    </div>
</div>
